export * from './directives';
export * from './services';
export { AgmCoreModule } from './core.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/@agm/core/index.js
// module id = ../../../../@agm/core/index.js
// module chunks = common